<template>
    <v-layout class="mt-3 mb-5 fast-select-2-page py-5" row wrap fill-height align-center justify-center>
        <v-flex xs12 sm10 md10 lg8 xl6
                v-match-heights="{el: ['.rezervation-item']}">
            <v-card class="pa-0 pb-3 rezervation-item" flat tile>
                <img class="img-responsive img-responsive-fast-select" :src="selectedAction.url"/>
                <v-card-title>
                    <div class="media-content">
                        <h3 class="headline mb-1" v-text="selectedAction.title"></h3>
                        <div class="card-content selected-action-popis" v-html="selectedAction.popis"></div>
                    </div>
                </v-card-title>
                <v-card-text class="pa-4">
                    <v-layout class="termin" row py-2 fill-height align-center justify-space-between
                            :key="nid"  v-for="({title, popis, url, kapacita, volna_mista, nid, field_akce_datum_od_do_value, field_akce_datum_od_do_value2, cena_za_prkno}) in events">
                        <v-layout class="text" row wrap xs8 sm9 md9 lg9 xl9 fill-height align-center justify-space-between>
                          <v-flex fill-height xs12 sm4 md6 lg6 xl6>
                            <p class="card-botom-content-item">
                                <v-icon light color="black" class="base-icn">fas fa-user</v-icon>
                                <span :class="['akce-kapacita__field', 'akce-kapacita__field--volna', volna_mista == 0 ? 'action-is-sold' : '']"
                                      v-text="volna_mista != 0 ? volna_mista + ' ' + freePlacesLabelFormated : 'vyprodáno'"></span>
                            </p>
                          </v-flex>
                          <v-flex fill-height xs12 sm8 md6 lg6 xl6>

                              <p class="card-botom-content-item middle">
                                  <v-icon light color="black" class="base-icn">fas fa-calendar-alt</v-icon>
                                  <span class="akce-kapacita__field akce-kapacita__field--plna"
                                        v-text="getDateOfAction(field_akce_datum_od_do_value)"></span>
                              </p>
                          </v-flex>
                        </v-layout>
                        <v-flex fill-height xs4 sm3 md3 lg3 xl3 align-center justify-center xs-justify-start>
                            <v-layout class="button" row justify-end>
                              <v-btn :disabled="volna_mista == 0" class="ma-1" depressed small color="primary"
                                   @click="selectService(nid)">Vybrat
                              </v-btn>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                    <!--<v-layout align-center justify-center class="mt-3">-->
                    <!--<v-btn-->
                    <!--class="ma-0"-->
                    <!--depressed large-->
                    <!--color="primary"-->
                    <!--@click="back"-->
                    <!--&gt;Zpět-->
                    <!--</v-btn>-->
                    <!--</v-layout>-->
                    <v-layout row wrap mt-3 fill-height align-center justify-start>
                        <v-btn
                                class="ma-0"
                                color="primary"
                                @click="back"
                        >Zpět
                        </v-btn>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import moment from 'moment-timezone'

    export default {
        name: "FastSelect-2",
        props: ['actionType'],
        computed: {
            selectedAction() {
//                return this.$store.state.serviceTypes[this.actionType];
                return this.$store.state.serviceTypes[this.$store.getters.getfastSelectChose];
            },
            events() {
                return this.$store.state.services.filter(item => item.node_typ_akce_nid == this.selectedAction.key && (!this.$store.state.selectLode || item.cena_doprava_lode != null));
            },
            freePlacesLabelFormated() {
                return this.volna_mista == 1 ? 'volné' : this.volna_mista < 5 ? 'volná' : 'volných';
            }
        },
        methods: {
            back() {
                this.$router.push('fast-select-1');
            },
            getDateOfAction(date) {
                var d = moment.utc(date).tz('Europe/Prague');

                return d.format('DD. MM. YYYY') + ' od ' + d.format('HH:mm');
            },
            selectService(id) {
                this.$store.dispatch('setService', id).then(() => {
                    this.$router.push({name: 'Step2', params: {actionID: id, prevRoute: 'FastSelect2'}});
                })
            },
        },
        beforeMount() {
            if (this.actionType != undefined) {
                this.$store.commit('setfastSelectChose', this.actionType);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/FastSelect2.vue